module.exports = __webpack_public_path__ + "img/front back rise 1.3245bd80.jpeg";